export default {
  login: {
    header: 'ورود به سیستم',
    subtitle: 'ایمیل و رمز عبور خود را برای ورود وارد کنید',
    email: 'ایمیل',
    password: 'رمز عبور',
    forgot: 'فراموشی رمز عبور؟',
    button: 'ورود به سیستم',
    'link-text': 'حساب کاربری ندارید؟',
    link: 'ثبت نام',
    networkStatus: 'مرکز عملیات شبکه (NOC): کلیه سیستم‌ها فعال هستند',
    secureBadge: 'درگاه امن سازمانی با رمزنگاری ۲۵۶ بیتی',
    telemetryTag: 'زیرساخت پیشرفته مخابرات و اینترنت',
    telemetryTitle: 'سامانه پایش فیبر نوری و عملیات شبکه',
    telemetryDesc: 'پایش بلادرنگ پهنای باند، همگام‌سازی مالی دفاتر با کیوبوکز، و نظارت ۲۴ ساعته بر زیرساخت ارتباطی در سراسر افغانستان.',
    sla: '۹۹.۹۸٪ پایداری شبکه',
    backbone: '۴ نود متصل',
    billingSync: 'همگام‌سازی زنده'
  },
  register: {
    header: 'ایجاد حساب کاربری',
    completeRegistration: 'تکمیل ثبت نام',
    verifying: 'در حال تایید دعوت‌نامه...',
    inviteOnly: 'ثبت‌نام فقط با دعوت‌نامه امکان‌پذیر است. از لینک ایمیل دعوت استفاده کنید یا با مدیر سیستم تماس بگیرید.',
    name: 'نام',
    email: 'ایمیل',
    password: 'رمز عبور',
    button: 'ثبت نام',
    completeButton: 'تکمیل ثبت نام',
    'link-text': 'قبلاً حساب کاربری دارید؟',
    link: 'ورود'
  },
  errors: {
    'fill-all': 'لطفاً تمام فیلدها را پر کنید.',
    'login-failed': 'لطفاً اطلاعات ورود خود را بررسی کنید و دوباره تلاش کنید.',
    'sign-in': 'خطایی در هنگام ورود رخ داد.',
    'registration': 'خطایی در هنگام ثبت نام رخ داد.',
    'invalid-invitation': 'لینک دعوت نامعتبر است یا منقضی شده است.'
  },
  success: {
    'registration': 'حساب کاربری شما ایجاد شد. لطفاً وارد شوید.',
    'registration-complete': 'ثبت نام تکمیل شد. لطفاً با حساب جدید خود وارد شوید.'
  },
  resetPassword: {
    title: 'بازنشانی رمز عبور',
    description: 'مراحل بازنشانی رمز عبور را دنبال کنید',
    email: 'ایمیل',
    emailPlaceholder: 'ایمیل خود را وارد کنید',
    otp: 'کد یکبار مصرف',
    otpPlaceholder: 'کد ۶ رقمی را وارد کنید',
    newPassword: 'رمز عبور جدید',
    newPasswordPlaceholder: 'رمز عبور جدید را وارد کنید',
    confirmPassword: 'تایید رمز عبور',
    confirmPasswordPlaceholder: 'رمز عبور جدید را تایید کنید',
    enterEmail: 'برای دریافت کد یکبار مصرف، ایمیل خود را وارد کنید',
    enterOTP: 'کد یکبار مصرف ارسال شده به ایمیل خود را وارد کنید',
    enterNewPassword: 'رمز عبور جدید خود را ایجاد کنید',
    sendOTP: 'ارسال کد',
    verifyOTP: 'تایید کد',
    submit: 'بازنشانی رمز عبور',
    success: {
      otpSent: 'کد یکبار مصرف به ایمیل شما ارسال شد',
      otpVerified: 'کد یکبار مصرف با موفقیت تایید شد',
      passwordReset: 'رمز عبور شما با موفقیت بازنشانی شد'
    },
    errors: {
      invalidEmail: 'لطفا یک ایمیل معتبر وارد کنید',
      invalidOTP: 'کد یکبار مصرف نامعتبر است',
      otpExpired: 'کد یکبار مصرف منقضی شده است',
      passwordMismatch: 'رمزهای عبور مطابقت ندارند',
      passwordLength: 'رمز عبور باید حداقل ۶ کاراکتر باشد',
      failed: 'بازنشانی رمز عبور با خطا مواجه شد',
      emailSendFailed: 'ارسال ایمیل با خطا مواجه شد. لطفا دوباره تلاش کنید',
      userNotFound: 'کاربر یافت نشد یا نشست منقضی شده است'
    },
    requestOTP: 'برای دریافت رمز یکبار مصرف از طریق ایمیل، روی دکمه زیر کلیک کنید'
  }
} 